import React from "react";
import { withRouter } from "react-router-dom";
import "./CommissionBreakdown.css";

const CommissionBreakdown = ({ 
    consultantBreakdown = [],
    currencySymbol = "$",
    history 
}) => {
    const sortedConsultants = consultantBreakdown;
    
    const maxCommission = sortedConsultants.length > 0 
        ? Math.max(...sortedConsultants.map(c => c.totalCommission)) 
        : 0;

    const getInitials = (firstName, lastName) => {
        const first = firstName ? firstName.charAt(0).toUpperCase() : '';
        const last = lastName ? lastName.charAt(0).toUpperCase() : '';
        return first + last || '??';
    };

    const getAvatarColor = (index) => {
        const colors = [
            'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
            'linear-gradient(135deg, #f97316 0%, #ea580c 100%)',
            'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            'linear-gradient(135deg, #ec4899 0%, #db2777 100%)'
        ];
        return colors[index % colors.length];
    };

    const handleViewDetails = () => {
        history.push("/agent/consultant");
    };

    return (
        <div className="commission-breakdown-card">
            <div className="commission-breakdown-header">
                <h3 className="commission-breakdown-title">
                    Commission Breakdown
                    {sortedConsultants.length > 0 && (
                        <span className="commission-breakdown-badge">{sortedConsultants.length}</span>
                    )}
                </h3>
                <button className="commission-breakdown-action" onClick={handleViewDetails}>
                    View Details
                </button>
            </div>
            <div className="commission-breakdown-body">
                {sortedConsultants.length === 0 ? (
                    <div className="commission-breakdown-empty">
                        <i className="fa fa-users"></i>
                        <p>No booking data for this period</p>
                    </div>
                ) : (
                    sortedConsultants.slice(0, 5).map((consultant, index) => (
                        <div key={consultant.id} className="commission-item">
                            <div 
                                className="commission-avatar"
                                style={{ background: getAvatarColor(index) }}
                            >
                                {getInitials(consultant.firstName, consultant.lastName)}
                            </div>
                            <div className="commission-details">
                                <div className="commission-name">{consultant.name}</div>
                                <div className="commission-role">{consultant.isConsultant ? "Consultant" : "Agent"}</div>
                                <div className="commission-bar">
                                    <div 
                                        className="commission-bar-fill"
                                        style={{ 
                                            width: maxCommission > 0 
                                                ? `${(consultant.totalCommission / maxCommission) * 100}%` 
                                                : '0%' 
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className="commission-stats">
                                <div className="commission-amount">
                                    {currencySymbol}{consultant.totalCommission.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}
                                </div>
                                <div className="commission-bookings-value">
                                    {currencySymbol}{consultant.totalBookingValue.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })} total gig fees
                                </div>
                                <div className="commission-avg">
                                    Avg {currencySymbol}{consultant.bookingCount > 0 ? Math.round(consultant.totalCommission / consultant.bookingCount).toLocaleString() : 0}/gig ({consultant.bookingCount} gig{consultant.bookingCount !== 1 ? 's' : ''})
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default withRouter(CommissionBreakdown);
